import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
const ServiceName = 'Events Broker Service';
export class BilEventBrokerService {
    constructor() {
        this.EventBus = new Subject();
    }
    subscribe(callback, selector, error, complete) {
        // Return an observable depending on how subscription was called
        if (typeof callback !== 'function') {
            throw new Error('No callback specified');
        }
        else {
            return this.EventBus.subscribe(event => (!selector || selector(event)) ? callback(event) : null, error, complete);
        }
    }
    publish(eventInfo) {
        if (!eventInfo) {
            throw new Error(`Publish method must get a valid event`);
        }
        else {
            this.EventBus.next(eventInfo);
        }
    }
}
BilEventBrokerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilEventBrokerService_Factory() { return new BilEventBrokerService(); }, token: BilEventBrokerService, providedIn: "root" });
